import httpClient from "http-client/http-client";

/**
 * Search venue suggestions via BFF-proxied Google Places Autocomplete.
 * @param {string} input - The search text typed by the user.
 * @param {string} sessionToken - UUID session token (group autocomplete + details calls for billing).
 * @returns {{ data: { suggestions: Array<{ placeId: string, description: string }> }, errors: [] }}
 */
/**
 * Search venue/city/area suggestions via BFF-proxied Google Places Autocomplete.
 * @param {string} input - The search text typed by the user.
 * @param {string} sessionToken - UUID session token (group autocomplete + details calls for billing).
 * @param {string} [types] - Optional Google Places primary type filter.
 *   "(cities)" for city search, "geocode" for area search, omit for venue search (default).
 * @returns {{ data: { suggestions: Array<{ placeId: string, description: string }> }, errors: [] }}
 */
export async function searchPlaces({ input, sessionToken, types }) {
  const { data, errors } = await httpClient.post({
    url: "v1/community-portal/location/places/autocomplete",
    body: { input, sessionToken, ...(types ? { types } : {}) },
  });
  if (errors && errors.length > 0) return { data: null, errors };
  return { data };
}

/**
 * Fetch parsed address fields for a selected place via BFF-proxied Google Places Details.
 * @param {string} placeId - Google place ID from autocomplete suggestion.
 * @param {string} sessionToken - Same UUID token used during the autocomplete phase.
 * @returns {{ data: { name, address_line_1, address_line_2, city, state, postal_code, country_code, geo_lat, geo_lng }, errors: [] }}
 */
export async function getPlaceDetails({ placeId, sessionToken }) {
  const { data, errors } = await httpClient.post({
    url: "v1/community-portal/location/places/details",
    body: { place_id: placeId, sessionToken },
  });
  if (errors && errors.length > 0) return { data: null, errors };
  return { data };
}
